import React from "react";
import "./layout.scss";
import { ReactComponent as LogoIcon } from "../../images/main-logo.svg"

const Header = () => {
  return (
    <div className="header-container">
      <div className="header-left">
        <div className="main-logo">
          <LogoIcon className="main-logo-svg" />
        </div>
        <div className="divider"></div>
        <div className="header-text">Questionnaire Manager</div>
      </div>
    </div>
  )
}

export default Header
